import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import Portal from "@/pages/Portal";
import EventLanding from "@/pages/EventLanding";
import Ticket from "@/pages/Ticket";
import RetrieveQR from "@/pages/RetrieveQR";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import EventCommand from "@/pages/EventCommand";
import Scanner from "@/pages/Scanner";
import Survey from "@/pages/Survey";
import Rsvp from "@/pages/Rsvp";
import Privacy from "@/pages/Privacy";
import Help from "@/pages/Help";
import Team from "@/pages/Team";
import Invite from "@/pages/Invite";
import Kiosk from "@/pages/Kiosk";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Portal />} />
      <Route path="/e/:slug" element={<EventLanding />} />
      <Route path="/ticket/:token" element={<Ticket />} />
      <Route path="/rsvp/:token" element={<Rsvp />} />
      <Route path="/retrieve-qr" element={<RetrieveQR />} />
      <Route path="/survey/:token" element={<Survey />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/help" element={<Help />} />
      <Route path="/invite/:token" element={<Invite />} />
      <Route path="/kiosk/:eventId" element={<Kiosk />} />
      <Route path="/moderator/login" element={<Login />} />
      <Route path="/moderator/dashboard" element={<Dashboard />} />
      <Route path="/moderator/team" element={<Team />} />
      <Route path="/moderator/events/:eventId" element={<EventCommand />} />
      <Route path="/scanner" element={<Dashboard />} />
      <Route path="/scanner/:eventId" element={<Scanner />} />
    </Routes>
  );
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} position="top-right" richColors />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRouter />
          <ThemedToaster />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
